import axios from "axios";

export const api = axios.create();

api.interceptors.response.use(
	(response) => response.data,
	(error) => {
		return Promise.reject(error);
	}
);

export const upload = (signatureUrl, imageBuffer, contentType) => {
	return api.put(signatureUrl, imageBuffer, {
		headers: {
			"Content-Type": contentType,
		},
	});
};
export const uploadVideo = (signatureUrl, imageBuffer, contentType) => {
	return api.put(signatureUrl, imageBuffer, {
		headers: {
			"Content-Type": contentType,
			"x-oss-object-acl": "private",
		},
	});
};
